import { render, staticRenderFns } from "./Trembling.vue?vue&type=template&id=0c09801d&scoped=true"
import script from "./Trembling.vue?vue&type=script&lang=js"
export * from "./Trembling.vue?vue&type=script&lang=js"
import style0 from "./Trembling.vue?vue&type=style&index=0&id=0c09801d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c09801d",
  null
  
)

export default component.exports